var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-container"},_vm._l((_vm.messages),function(message,key){return _c('message-container-item',_vm._b({key:("message-" + key)},'message-container-item',message,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }